<template>
  <div v-full-height="true">
    <block-group label="Историческая статистика" class="mb-4" v-if="historical">
      <div class="d-flex flex-row align-items-start justify-content-between wd-100p-force mb-3">
        <div class="form-group wd-48p-force">
          <label class="form-label">Всего номеров</label>
          <div class="form-control-plaintext">{{ formatNumber(historical.stats_numbers_total) || '-' }}</div>
        </div>
        
        <div class="form-group wd-48p-force">
          <label class="form-label">Осталось номеров</label>
          <div class="form-control-plaintext">{{ formatNumber(historical.stats_numbers_remain) || '-' }}</div>
        </div>
      </div>
      <div class="d-flex flex-row align-items-start justify-content-between wd-100p-force mb-3">
        <div class="form-group wd-48p-force">
          <label class="form-label">В стоп-листе</label>
          <div class="form-control-plaintext">{{ formatNumber(historical.stats_numbers_blacklist) || '-' }}</div>
        </div>
        <div class="form-group wd-48p-force">
          <label class="form-label">Запрет вызова (повтор за 3 дня)</label>
          <div class="form-control-plaintext">{{ formatNumber(historical.stats_weekly_not_call) || '-' }}</div>
        </div>
      </div>
      <div class="d-flex flex-row align-items-start justify-content-between wd-100p-force mb-3">
        <div class="form-group wd-48p-force">
          <label class="form-label">Номера в обработке</label>
          <div class="form-control-plaintext">{{ formatNumber(historical.stats_numbers_in_progress) || '-' }}</div>
        </div>
        <div class="form-group wd-48p-force">
          <label class="form-label">Завершено</label>
          <div class="form-control-plaintext">{{ formatNumber(historical.stats_numbers_finished) || '-' }}</div>
        </div>
      </div>
      <div class="d-flex flex-row align-items-start justify-content-between wd-100p-force mb-3">
        <div class="form-group wd-48p-force">
          <label class="form-label">Успешный звонок</label>
          <div class="form-control-plaintext">{{ formatNumber(historical.stats_numbers_called) || '-' }}</div>
        </div>
        <div class="form-group wd-48p-force">
          <label class="form-label">Неуспешный звонок</label>
          <div class="form-control-plaintext">{{ formatNumber(historical.stats_numbers_uncalled) || '-' }}</div>
        </div>
      </div>
      <div class="d-flex flex-row align-items-start justify-content-between wd-100p-force mb-3">
        <div class="form-group wd-48p-force">
          <label class="form-label">Входящие</label>
          <div class="form-control-plaintext">{{ formatNumber(historical.stats_numbers_incoming) || '-' }}</div>
        </div>
        <div class="form-group wd-48p-force">
          <label class="form-label">Нажато</label>
          <div class="form-control-plaintext">{{ formatNumber(historical.stats_numbers_pressed) || '-' }}</div>
        </div>
      </div>
    </block-group>
  </div>
</template>

<script>
import DistributionClass from "@/entities/Distributions/DistributionClass";
import BlockGroup from "@/elements/BlockGroup.vue";
import DateFormatted from "@/elements/DateFormatted.vue";

export default {
  components: { BlockGroup, DateFormatted },
  props: { element: { type: Object } },
  data() {
    return {
      Distribution: null,
      loading: false,
      distribution: {},
      historical: null
    }
  },
  mounted() {
    this.Distribution = new DistributionClass(this);
    this.loadData();
  },
  methods: {
    loadData() {
      if (!this.$props.element || !this.$props.element.id) {
        return;
      }

      this.loading = true;
      this.Distribution.listItem(this.$props.element.id, (item) => {
        this.distribution = item;
        
        // Парсим historical данные (может быть двойной JSON)
        if (item.historical) {
          try {
            let parsed = typeof item.historical === 'string' 
              ? JSON.parse(item.historical) 
              : item.historical;
            
            // Если результат - строка, парсим еще раз
            if (typeof parsed === 'string') {
              parsed = JSON.parse(parsed);
            }
            
            this.historical = parsed;
          } catch (e) {
            console.error('Ошибка парсинга historical:', e);
            this.historical = null;
          }
        } else {
          this.historical = null;
        }
        
        this.loading = false;
      }, () => {
        this.loading = false;
      });
    },
    getStatusLabel(status) {
      const statusMap = {
        'active': 'Активна',
        'paused': 'На паузе',
        'paused_out_time': 'На паузе (вне времени)',
        'finished': 'Завершена',
        'created': 'Создана',
        'stopped': 'Остановлена'
      };
      return statusMap[status] || status;
    },
    getStatusClass(status) {
      const classMap = {
        'active': 'tx-success',
        'paused': 'tx-warning',
        'paused_out_time': 'tx-warning',
        'finished': 'tx-info',
        'created': 'tx-secondary',
        'stopped': 'tx-danger'
      };
      return classMap[status] || '';
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '-';
      return parseInt(value).toLocaleString('ru-RU');
    },
    formatPrice(value) {
      if (value === null || value === undefined || value === '') return '-';
      return parseFloat(value).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₽';
    }
  }
}
</script>

<style scoped>
.form-control-plaintext {
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--cui-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
</style>

